import { useCallback, useMemo } from 'react';

import { useShopProvider } from '#provider/useShopProvider.js';
import { useShowConsumerStoreItem } from '@givebacks/api/store';
import { useShowCauseW_Selector } from 'core/Api';
import { useParams } from 'react-router-dom';

/**
 * Custom hook for managing route-related store data.
 * Returns any needed store data based on the route/storeId
 */
const useRouteStore = () => {
  const { storeId: storeIdParam, itemId } = useParams();
  const { getStoreId } = useShopProvider();

  const storeId = useMemo(() => {
    if (getStoreId) {
      return getStoreId();
    } else {
      return storeIdParam;
    }
  }, [getStoreId, storeIdParam]);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- API response is safe
  const { data: causeId, isLoading: isCauseLoading } = useShowCauseW_Selector({
    uuid: storeId,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return -- API response is safe
    select: useCallback((data) => data?.uuid, []),
  });

  return {
    itemId,
    storeId: causeId,
    isCauseLoading,
    useShowStore: () => useShowCauseW_Selector({ uuid: causeId }),
    useShowStoreItem: () =>
      useShowConsumerStoreItem({ causeId: causeId, uuid: itemId, include: 'inventory_summary' }),
    getStoreId,
  };
};

export { useRouteStore };
